<template>
  <div :class="$options.name">
    <v-card :loading="isLoading">
      <object-form-create-form
        @submit="onCreate"
      />
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ObjectFormCreateForm from '@/views/settings/object-form/components/ObjectForm.vue';

export default {
  name: 'object-form-create',
  components: { ObjectFormCreateForm },
  data: () => ({
    isLoading: false,
    form: null,
  }),
  methods: {
    ...mapActions('objectForms', ['create']),
    ...mapActions(['showNotify']),
    async onCreate(form) {
      this.isLoading = true;
      const objectForm = await this.create(form);

      this.showNotify({ message: 'Форма успешно создана' });

      this.isLoading = false;

      await this.$router.push({ name: 'object-form-item', params: { id: objectForm.id } });
    },
  },
};
</script>

<style scoped>

</style>
